import _ from 'lodash';
import { fetchApi } from '../utils';

const getSettingsApi = () => {
  return fetchApi('settings').then(res => _.get(res, 'data'));
};

const saveSettingsApi = ({ name, value }) => {
  return fetchApi('settings', 'POST', JSON.stringify({ name, value }));
};

export { getSettingsApi, saveSettingsApi };



// WEBPACK FOOTER //
// ./src/services/settings.js